module.exports = __webpack_public_path__ + "static/media/headermobile.a7e17622.png";